var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { setInstrument } from "../../../../../../../redux/actions/canvas/canvas";
export var LaserPointer = function () {
    var instrument = useSelector(function (state) { return state.canvas; }).instrument;
    var instrumentToggle = function () { return setInstrument('laser-pointer'); };
    return (_jsx(Button, __assign({ onClick: instrumentToggle, title: "Laser Pointer", className: clsx({
            "remove-button-text": true,
            active: instrument === "laser-pointer",
        }) }, { children: _jsx("svg", __assign({ width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsxs("g", __assign({ transform: "rotate(45 12 12)" }, { children: [_jsx("circle", { cx: "12", cy: "2.5", r: "1.7", strokeWidth: "1", stroke: "red", vectorEffect: "non-scaling-stroke" }), _jsx("rect", { x: "10", y: "7", width: "4", height: "13", rx: "2", stroke: "currentColor", strokeWidth: "1", fill: "#red", vectorEffect: "non-scaling-stroke" })] })) })) })));
};
